import { apiClient } from './ApiService';

interface WindscreenStatusResponse {
  status: number;
  message: string;
  data: {
    current_ip: string;
    service_status: string;
  };
}

interface WindscreenUpdateResponse {
  status: number;
  message: string;
  data: {
    output: string;
  };
}

/**
 * Get the current drone IP address and windscreen service status
 * @returns Promise with the windscreen status response
 */
const getStatus = async (): Promise<WindscreenStatusResponse> => {
  try {
    return await apiClient.get<WindscreenStatusResponse>('/drone_commander/windscreen/status/');
  } catch (error) {
    console.error('Error fetching windscreen status:', error);
    throw error;
  }
};

/**
 * Update the drone IP address
 * @param ipAddress - The new IP address to set
 * @returns Promise with the update response
 */
const updateIpAddress = async (ipAddress: string): Promise<WindscreenUpdateResponse> => {
  try {
    return await apiClient.post<WindscreenUpdateResponse>('/drone_commander/windscreen/update-ip/', {
      ip_address: ipAddress
    });
  } catch (error) {
    console.error('Error updating drone IP address:', error);
    throw error;
  }
};

export const WindscreenService = {
  getStatus,
  updateIpAddress
};
